import { ReactComponent as BurgerSVG } from "../assets/burger.svg";

function LeftMenuBurger({ onClick }: { onClick: Function }) {
  return (
    <div>
      <button
        type="button"
        className="left-menu-burger"
        onClick={() => onClick()}
      >
        <BurgerSVG />
      </button>
    </div>
  );
}

export default LeftMenuBurger;
